/* eslint semi:0 */
import dom from 'utils/dom'
import userStore from 'stores/userStore'
import { BaseStore, } from 'stores/baseStore'
import { mithrilHelpers } from 'utils/mithril'
import pageDataObject from 'application/pageDataObject'
import userActions from 'actions/userToolbarActions'
import embedCodeModalActions from 'actions/embedCodeModalActions'


let EMBED_CODE_API = `/posts/${ pageDataObject.get('post.id') }/embed_code`

let lazySingletonInstance = null

export default class EmbedCodeModalStore extends BaseStore {

  static getInstance(){
    if (!lazySingletonInstance) {
      lazySingletonInstance = EmbedCodeModalStore.create()
    }
    return lazySingletonInstance
  }

  constructor(options = {}) {
    super(options)
    this.fetchModalData()
  }

  routeAction(action) {
    let { type } = action;
    let ACTIONS = embedCodeModalActions.TYPES;
    switch (type) {
      case ACTIONS.EMBED_DATA_RECEIVED:
        return this.onDataReceived(action.data)
      case ACTIONS.EMBED_DATA_FAILED:
        return this.onDataError()
      case ACTIONS.EMBED_CONFIGURATION_CHANGED:
        return this.onConfigurationChanged(action.configOption)
      case userActions.TYPES.FB_LOGIN:
        return (this.state.dataReady = false)
      case userActions.TYPES.EXISTING_USER_AUTHENTICATED:
        return this.fetchModalData()
      default:
        return this
    }
  }


  fetchModalData() {
    let timeStamp = userStore.partnerId ? Date.now() : 'notPartner'
    mithrilHelpers
      .safeRequest({
        method: 'GET',
        url: EMBED_CODE_API,
        data: {
          ts: timeStamp,
        },
      })
      .then(
        embedCodeModalActions.embedDataReceived,
        embedCodeModalActions.embedDataFailed
      )
  }

  onDataReceived(data){
    Object.assign(this.state, data)
    this.embedCodeElement = dom.createElement('div')
    this.embedCodeElement.innerHTML = data.embed_code
    this.state.dataReady = true
    this.emitChange()
  }

  onDataError(){
    this.state.dataError = true
    this.emitChange()
  }

  onConfigurationChanged(configOption){
    let newValue = !this.state.configuration[configOption]
    this.state.configuration[configOption] = newValue
    let elementAction = newValue ? 'setAttribute' : 'removeAttribute'
    this.embedCodeElement.children[0][elementAction](`data-${configOption}`, '')
    this.emitChange()
  }

  get embedCodePretty(){
    let str = this.embedCodeElement.innerHTML
    return str.replace(/=\"\"/g, '')
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/embedCodeModalStore.js